import { connect } from "react-redux";

import { selectRightSidebarActiveItems } from "~/store/ducks/user/uistate";
import { selectDisplayedPages } from "~/store/selectors/page";
import {
  selectFilteredPagelessMaterials,
  moveMaterial
} from "~/store/ducks/application/materials/materials";

import NonAssignedMaterialsList from "./NonAssignedMaterialsList";

const mapStateToProps = state => {
  const activeItems = selectRightSidebarActiveItems(state);
  const materials = selectFilteredPagelessMaterials(activeItems)(state);
  const activePages = selectDisplayedPages(state);

  return {
    materials,
    activePages
  };
};

const mapDispatchToProps = dispatch => ({
  onDrop: item => {
    const position = {
      ...item.position,
      page: -1
    };

    dispatch(moveMaterial(item._id, item.position._id, position));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonAssignedMaterialsList);
